import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { FileText, Search } from "lucide-react";

// Using public folder path for stable loading
const heroBanner = "/images/banner-hero.png";

const HeroSection = () => {
  return (
    <section 
      className="py-20 md:py-32 bg-cover bg-center bg-no-repeat relative"
      style={{ backgroundImage: `url(${heroBanner})` }}
    >
      
      <div className="container relative z-10 flex flex-col items-center">
        <div className="text-center">
          <p 
            className="text-base md:text-lg lg:text-xl text-white/90 mb-2 animate-fade-in"
            style={{ textShadow: '0 0 4px rgba(0, 0, 0, 0.4)' }}
          >
            The fastest and easiest way to
          </p>
          <h1 
            className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-10 animate-fade-in"
            style={{ textShadow: '0 0 4px rgba(0, 0, 0, 0.4)' }}
          >
            Connect Gemstone Buyers and Sellers
          </h1>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 justify-center opacity-0 animate-fade-in" style={{ animationDelay: "0.2s" }}>
          <Link to="/post-request">
            <Button variant="hero" size="lg" className="gap-2 min-w-[200px] justify-center">
              Post a Buying Request
              <FileText className="h-5 w-5" />
            </Button>
          </Link>
          <Link to="/listings">
            <Button variant="hero" size="lg" className="gap-2 min-w-[200px] justify-center">
              Browse Buying Requests
              <Search className="h-5 w-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
